<template>
  <div
    class="org-card"
    @click="jumpOrgPage"
    :class="{ 'electron-org-card': isElectron }"
  >
    <img class="logo" :src="handleOrgLogo" alt="" />
    <div class="org-info">
      <p class="title">
        {{ orgInfo.org_name }}
      </p>
      <p class="desc">
        {{ orgInfo.org_desc }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    orgInfo: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {
      isElectron: window.isElectron,
    };
  },
  methods: {
    jumpOrgPage() {
      this.$router.push(`/org/${this.orgInfo.org_id}`);
    },
  },
  computed: {
    //机构logo
    handleOrgLogo() {
      if (this.orgInfo?.org_logo) {
        return this.orgInfo.org_logo + "?imageView2/0/w/100";
      } else {
        return "https://cdn.comettech.com/cdn/static/images/default_org_logo.png?imageView2/0/w/100";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// 客户端
.org-card.electron-org-card {
  width: 310px;
}
.org-card {
  cursor: pointer;
  width: 380px;
  height: 93px;
  background: #ffffff;
  border-radius: 24px;
  display: flex;
  align-items: center;
  padding: 0 12px;
  .logo {
    width: 70px;
    height: 70px;
    background: #ffffff;
    border-radius: 16px;
    border: 1px solid #e2e2e2;
    object-fit: cover;
    margin-right: 12px;
  }
  .org-info {
    flex: 1;
    width: 0;
    height: 70px;
  }
  .title {
    font-weight: 500;
    font-size: 18px;
    color: #000000;
    line-height: 25px;
    margin-bottom: 2px;
    line-break: anywhere;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .desc {
    font-size: 14px;
    color: #515350;
    line-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-break: anywhere;
  }
}
</style>
